import React, { Component } from 'react';
import Chart from "react-apexcharts";
import axios from 'axios'
import { Circles } from 'react-loader-spinner'

export class TTCBCchart extends Component {
    constructor() {
        super()
        this.state = {
            options: {
                chart: {
                    type: "bar"
                },
                xaxis: {
                    categories: []
                }
            },
            series: [],
            isLoaded: false,
            filterDateTo: '',
            filterDateFrom: '',
            lineChart : {
                series: [
                  {
                    name: "Shipment Cost",
                    data: []
                  }
                ],
                options: {
                  chart: {
                    type: 'line',
                    height: 350
                  },
                  title: {
                    text: 'Shipment Costs by Month',
                    align: 'left'
                  },
                  xaxis: {
                    categories: [],
                    title: {
                      text: 'Months'
                    }
                  },
                  yaxis: {
                    title: {
                      text: 'Cost (Rs.)'
                    }
                  }
                }
            }
        };
        this.componentDidMount = this.componentDidMount.bind(this)
        this.filterChnage = this.filterChange.bind(this)
        this.updateChart = this.updateChart.bind(this)
    }

    updateState(name, data) {
        const newSeries = {
            name: name,
            data: data
        };

        this.setState((prevState) => ({
            series: [...prevState.series, newSeries]
        }));
    }

    updateLineChart(cost,month){

    }
   
    updateLoader(stateValue) {
        if (this.state.isLoaded === true) {
            this.setState({ isLoaded: false })
        } else {
            this.setState({ isLoaded: stateValue })
        }
    }

    updateCategories(newCategories) {
        this.setState((prevState) => ({
            options: {
                ...prevState.options, // Preserve other properties in the options object
                xaxis: {
                    ...prevState.options.xaxis, // Preserve other properties in xaxis
                    categories: newCategories, // Update categories with the new data
                },
            },
        }));
    }

    filterChange(key, event) {
        console.log(key + " " + event.target.value)
        if (key == 'to') {
            this.setState({ filterDateTo: event.target.value })
        } else if (key == 'from') {
            this.setState({ filterDateFrom: event.target.value })
        }
    }

    getData(formData) {
        const API_URL = process.env.REACT_APP_API_URL
        const token = localStorage.getItem("authTokenLoop");
        const dataUrl = API_URL + "/Bi_dashboard_ttc_bc"

        const data_record = [];
        const data_name = [];

        axios({
            method: 'post',
            url: dataUrl,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data', // Set the Content-Type header to multipart/form-data
                'Authorization': 'Bearer ' + token,
            },
        }).then((response) => {
            if (response.data.success) {
                const reportData = response.data.data;
                reportData.forEach(item => {
                    data_record.push(item.tms_shp_trip_cost);
                    data_name.push(item.sup_code);
                });
                const costs = response.data.costs;
                const months = response.data.months;
                console.log("COSTS",costs);
                console.log("MONTHS",months);
                console.log([1,2,3])
                this.setState({ series: [] })
                this.setState({ options: { chart: { type: "bar" }, xaxis: { categories: [] } } })
                this.setState({lineChart:{
                    series: [
                      {
                        name: "Shipment Cost",
                        data: costs
                      }
                    ],
                    options: {
                      chart: {
                        type: 'line',
                        height: 350
                      },
                      title: {
                        text: 'Shipment Costs by Month',
                        align: 'left'
                      },
                      xaxis: {
                        categories: months,
                        title: {
                          text: 'Months'
                        }
                      },
                      yaxis: {
                        title: {
                          text: 'Cost (Rs.)'
                        }
                      }
                    }
                }})
                this.updateCategories(data_name)
                this.updateState("Cost", data_record)
                this.updateLoader(true)
            } else {
                console.log("No data returned from API")
                this.updateLoader(true)
            }

        }).catch(function (error) {
            console.log(error);
        });
    }

    updateChart() {
        const filterDateTo = this.state.filterDateTo;
        const filterDateFrom = this.state.filterDateFrom;
        const formData = new FormData();
        formData.append('filter_date_to', filterDateTo);
        formData.append('filter_date_from', filterDateFrom);
        this.setState({ isLoaded: false })
        this.getData(formData);
    }

    componentDidMount() {
        const formData = new FormData();
        var currentDate = new Date();

        currentDate = new Date(currentDate.getTime() - 86400000);
        var formattedDateFrom = currentDate.toISOString().split('T')[0];

        currentDate = new Date();
        var formattedDateTo = currentDate.toISOString().split('T')[0];

        formData.append('filter_date_to', formattedDateTo);
        formData.append('filter_date_from', formattedDateFrom);

        this.setState({ filterDateTo: formattedDateTo })
        this.setState({ filterDateFrom: formattedDateFrom })

        this.getData(formData);
    }

    render() {
        return (
            <div className={`card col-12 m-4`} style={{ width: '97%' }}>
                <div className='card-header border-0 pt-5'>
                    <div className='row'>
                        <div className='col-10'>
                            <h3 className='card-title align-items-start flex-column'>
                                <span className='card-label fw-bold fs-3 mb-1'>
                                    Total Transport Cost
                                    <br /> <span style={{ color: '#A3A5A6' }}>{this.state.filterDateFrom} to {this.state.filterDateTo}</span>
                                </span>
                            </h3>
                        </div>
                        <div className='col-2'>
                            <button
                                type='button'
                                className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                                data-kt-menu-trigger='click'
                                data-kt-menu-placement='bottom-end'
                                data-kt-menu-flip='top-end'
                                style={{ width: '7vh' }}>
                                <i className='fas fa-filter mx-1'></i> Filter
                            </button>

                            <div className='menu menu-sub menu-sub-dropdown w-250px w-md-300px' data-kt-menu='true'>
                                <div className='px-7 py-5'>
                                    <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
                                </div>

                                <div className='separator border-gray-200'></div>

                                <div className='px-7 py-5'>
                                    <div className='mb-10'>
                                        <label className='form-label fw-bold'>Filter From Date:</label>
                                        <div>
                                            <input type="Date" name='date' value={this.state.filterDateFrom}
                                                onChange={(event) => this.filterChange('from', event)}
                                                className='form-control' />
                                        </div>
                                    </div>

                                    <div className='mb-10'>
                                        <label className='form-label fw-bold'>Filter To Date:</label>
                                        <div>
                                            <input type="Date" name='date' value={this.state.filterDateTo}
                                                onChange={(event) => this.filterChange('to', event)}
                                                className='form-control' />
                                        </div>
                                    </div>

                                    <div className='d-flex justify-content-end'>
                                        <button
                                            type='reset'
                                            className='btn btn-sm btn-white btn-active-light-primary me-2'
                                            data-kt-menu-dismiss='true'>
                                            Reset
                                        </button>

                                        <button type='submit' className='btn btn-sm btn-primary' data-kt-menu-dismiss='true' onClick={this.updateChart}>
                                            Apply
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                <div className='card-body'>
                    <div id='loader' className={this.state.isLoaded == true && 'd-none'} style={{ height: "50%", width: "50%" }}>
                        <Circles
                            height="100%"
                            width="40%"
                            color="#FF870D"
                            ariaLabel="circles-loading"
                            wrapperStyle={{ padding: "15% 0", marginLeft: "16%" }}
                            wrapperClass=""
                            visible={true}
                        />
                    </div>

                    <div id='loader' className={!this.state.isLoaded == true && 'd-none'} style={{ height: "100%" }}>
                        {/* <Chart
                            options={this.state.options}
                            series={this.state.series}
                            type="bar"
                            width="100%"
                            height="150%"
                        /> */}
                         <Chart
                            options={this.state.lineChart.options}
                            series={this.state.lineChart.series}
                            type="line"
                            height={350}
                            />
                    </div>
                </div>
            </div>
        )
    }
}